// Route paths for the KEYAR telemetry WebSocket feed, appended to a
// urls.*_WS_URL base.
export const KEYAR_WS_ROUTES = {
    // Per-patient route (spec §2.2.B): pushes one patient's telemetry.
    PATIENT: (patientId) => `ws/cms/patient/${patientId}/`,

    // Facility/ward-scoped route (spec §2.2.A, confirmed 2026-09):
    // streams every active bed/device at one place_id over one connection.
    // Takes a single place_id, not a list.
    PLACE: (placeId) => `ws/cms/place/${placeId}/`,
};
